exports.GRAPHQL_PATH = '/soa/graphql/';
exports.QUERY_STRING_HEADER = 'x-dibs-query-params';
